// extracted by mini-css-extract-plugin
export default {"wrapper":"SmallStatusLevelsList_wrapper__SCsCA","divider":"SmallStatusLevelsList_divider__1crv-"};